function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16345 7.16344 0 16 0C24.8366 0 32 7.16345 32 16Z",
  fill: "#051E56"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4508 7.89183C14.2268 7.95344 14.1005 8.19042 14.1741 8.41074L16.651 15.8208C16.7778 16.1999 16.5645 16.6084 16.1811 16.7212C15.7994 16.8336 15.4003 16.6081 15.2995 16.2232L13.3291 8.70115C13.2652 8.45703 13.0135 8.31274 12.7705 8.38089C12.594 8.43039 12.465 8.58172 12.444 8.76383L10.9031 22.1261C10.8073 22.9564 11.712 23.5308 12.4227 23.091L16.8935 20.3243C17.0516 20.2265 17.2338 20.1747 17.4197 20.1747H22.7681C23.6135 20.1747 24.0775 19.1908 23.5397 18.5385L14.8707 8.02468C14.7691 7.90151 14.6047 7.84949 14.4508 7.89183Z",
  fill: "white"
});

function SvgLogoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.9c8ab0b1.svg";
export { ForwardRef as ReactComponent };